import { BaseClient } from '@/api'

export class EmployeeClient extends BaseClient {
  constructor(
  ) {
    super('employees')
  }
}
